"use strict";
/**
 * @fileoverview API response body interface for customer migration endpoint
 * Defines the structure returned by the deprecated fields migration operation
 */
Object.defineProperty(exports, "__esModule", { value: true });
